import { jsx as e } from "react/jsx-runtime";
import t from "./styles.module.less.js";
const c = ({
  id: o,
  checked: i,
  disabled: r = !1,
  className: s,
  innerClassName: a
}) => /* @__PURE__ */ e(
  "div",
  {
    id: o,
    className: `${t.radioInputButton} ${s ?? ""} ${i ? t.checked : ""} ${r ? t.disabled : ""}`,
    children: /* @__PURE__ */ e("div", { className: `${t.innerRadio} ${a ?? ""}` })
  }
);
export {
  c as RadioInputButton
};
